import { useEffect, useRef, useState } from "react";
import api from "../services/api";

export const useSearchSuggest = (query, enabled = true) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const last = useRef("");

  useEffect(() => {
    const q = (query || "").trim();
    if (!enabled || q.length < 2) { setItems([]); setTotal(0); setLoading(false); return undefined; }
    setLoading(true);
    const ctrl = new AbortController();
    const t = setTimeout(() => {
      last.current = q;
      api.get("/search/suggest", { params: { q }, signal: ctrl.signal })
        .then(({ data }) => { if (last.current === q) { setItems(data.items || []); setTotal(data.total || 0); } })
        .catch(() => {})
        .finally(() => { if (last.current === q) setLoading(false); });
    }, 220);
    return () => { clearTimeout(t); ctrl.abort(); };
  }, [query, enabled]);

  return { items, total, loading };
};
